<template>
  <div role="button" class="button sort">
    <span class="tip">位置の移動</span>
    <!-- <FontawesomeIcon icon="angle-up" size="sm" class="icn up" />
    <FontawesomeIcon icon="angle-down" size="sm" class="icn down" /> -->
    <IcArrowTop class="icn sm up"/>
    <IcArrowDown class="icn sm down"/>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from 'vue'


export default defineComponent({
  props: {
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {

    const group1 = reactive({
      isChecked: computed(() => { return props.isChecked })
    })

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.sort {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 30px;
  position: relative;
  color: $color-content;
  border-radius: 4px;
  transition: box-shadow .2s;
  .icn {
    position: absolute;
    left: 50%;
    transform: translate3d(-50%,0,0);
    color: $color-link;
    &.up {
      top: 3px;
    }
    &.down {
      bottom: 3px;
    }
  }
  .tip {
    color: $color-link;
    font-size: 1.4rem;
    white-space: nowrap;
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translate3d(-50%,0,0);
    opacity: 0;
    transition: opacity .2s;
  }
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.16);
   .tip {
     opacity: 1;
   } 
  }
}
</style>
